import { formatDate } from "helpers";

const formatTimeRange = (start: string, end: string): string => {
  const timeStart = formatDate(start, { timeStyle: "short" });
  const timeEnd = formatDate(end, { timeStyle: "short" });

  return `${timeStart} - ${timeEnd}`;
};

export { formatTimeRange };
